import { inject } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';

import { LanguageService } from '@app/core/language-service';

/**
 * Redirect UrlTree for the current language. Guards must never redirect to a raw unlocalized path — the
 * app serves prefixed routes (`/ro/...`, `/pt/...`) and a hard-coded `/` would drop the locale.
 * Must be called from an injection context (inside a functional guard body).
 */
export const localizedUrlTree = (url: string): UrlTree => {
  const router = inject(Router);
  const languageService = inject(LanguageService);

  return router.createUrlTree([languageService.getCurrentLangUrl(url)]);
};
